import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../state/hooks';
import { IncidentStepperQuery } from './incidentStepper.interface';

export interface IncidentStepperQueryState {
  queryParams: IncidentStepperQuery;
}

const initialState: IncidentStepperQueryState = {
  queryParams: {
    activeStep: 0,
  },
};

export const incidentStepperQuerySlice = createSlice({
  name: 'incidentStepperQuery',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    dispatchPageQuery(state, action: PayloadAction<any>) {
      // eslint-disable-next-line no-param-reassign
      state.queryParams = {
        ...state.queryParams,
        ...action.payload,
      };
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {},
});

export const { dispatchPageQuery } = incidentStepperQuerySlice.actions;

export const incidentStepperQuerySelector = (
  state: RootState,
): IncidentStepperQuery => {
  return state.incidentStepperQuery.queryParams;
};
